

import React, { useEffect, useState } from 'react';
import CreatableSelect, { components } from 'react-select';
import classes from './OnboardingComponents.module.scss';
import { getUpcomingEvents, getDefaultUserCommunities } from 'lib/user';

const CommunityActivity = () => {
  const [profile, setProfile] = useState({});
  const [communities, setCommunities] = useState([]);
  const [events, setEvents] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const defaultCommunities = getDefaultUserCommunities();

  useEffect(() => {
    const communityVals = communities.map(c => c.icon);
    const fetchedEvents = getUpcomingEvents(communityVals);
    setUpcomingEvents(fetchedEvents);
  }, [communities]);

  // Load from session storage
  useEffect(() => {
    const storedProfile = JSON.parse(sessionStorage.getItem('profile')) || {};
    setProfile(storedProfile);
    setCommunities(storedProfile.communities || []);
    setEvents(storedProfile.events || []);
  }, []);

  const updateProfile = (newData) => {
    const updatedProfile = {
      ...profile,
      ...newData
    };
    sessionStorage.setItem('profile', JSON.stringify(updatedProfile));
    setProfile(updatedProfile);
  };

  const handleCommunityChange = (selectedOption) => {
    const exists = communities.some(c => c.value === selectedOption.value);
    if (exists) return;
    const newCommunities = [...communities, selectedOption];
    setCommunities(newCommunities);
    updateProfile({ communities: newCommunities });
  };

  const handleEventChange = (selectedOption) => {
    const exists = events.some(c => c.value === selectedOption.value);
    if (exists) return;
    const newEvents = [...events, selectedOption];
    setEvents(newEvents);
    updateProfile({ events: newEvents });
  };

  const removeCommunity = (community) => {
    const updatedCommunities = communities.filter(c => c.value !== community.value);
    setCommunities(updatedCommunities);
    updateProfile({ communities: updatedCommunities });

    // Recalculate upcoming events
    const updatedCommunityVals = updatedCommunities.map(c => c.icon);
    const newUpcomingEvents = getUpcomingEvents(updatedCommunityVals);
    setUpcomingEvents(newUpcomingEvents);

    // Remove events not in the new upcomingEvents
    const validEventValues = newUpcomingEvents.map(e => e.value);
    const filteredEvents = events.filter(e => validEventValues.includes(e.value));
    setEvents(filteredEvents);
    updateProfile({ events: filteredEvents });
  };

  const removeEvent = (event) => {
    const updated = events.filter(e => e.value !== event.value);
    setEvents(updated);
    updateProfile({ events: updated });
  };

  const NoOptionsMessage = (props) => {
    const {
      selectProps: { inputValue }
    } = props;

    const handleClick = () => {
      const newOption = { value: inputValue, label: inputValue };
      props.selectProps.onChange(newOption);
      props.selectProps.onInputChange('');
      props.selectProps.onMenuClose();
    };

    return (
      <components.NoOptionsMessage {...props}>
        <div className="select-no-options" onClick={handleClick}>
          {inputValue ? `Add: ${inputValue}` : "No options"}
        </div>
      </components.NoOptionsMessage>
    );
  };

  return (
    <div className={classes.communitySelectionContainer}>
      <h1 className={classes.title}>Are you active in a community?</h1>
      <div className={classes.subtitle}>Communities and events are how you'll find others</div>
      <div className={classes.selectionGroup}>
        <div className={classes.sentenceText}>Active in:</div>
        <CreatableSelect
          id="community"
          onChange={handleCommunityChange}
          onCreateOption={handleCommunityChange}
          placeholder="Community Name"
          options={defaultCommunities}
          isSearchable={true}
          formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
          components={{ NoOptionsMessage }}
          classNamePrefix="select"
          styles={{ control: (base) => ({ ...base, borderRadius: '0.75em' }) }}
        />
        <div className={classes.communities}>
            {communities && communities.length > 0 && (
                communities
                    .map((community, index) => (
                        <div className={`${classes.tag} ${classes.community}`} key={index}>
                            <img className={classes.communityIcon} src={`/community-icons/${community.icon}.png`} alt={community.value} />
                            {community.value}
                            <div
                                className={classes.smallDeleteButton}
                                onClick={() => removeCommunity(community)}
                            />
                        </div>
                    ))
            )}
        </div>
      </div>
      <div className={classes.selectionGroup}>
        <div className={classes.sentenceText}>Going to:</div>
        <CreatableSelect
          id="events"
          onChange={handleEventChange}
          onCreateOption={handleEventChange}
          placeholder="Upcoming Events"
          options={upcomingEvents}
          isSearchable={true}
          formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
          components={{ NoOptionsMessage }}
          classNamePrefix="select"
          styles={{ control: (base) => ({ ...base, borderRadius: '0.75em' }) }}
        />
        <div className={classes.communities}>
            {events && events.length > 0 && (
                events
                    .map((event, index) => (
                        <div className={`${classes.tag} ${classes.community}`} key={index}>
                            <img className={classes.communityIcon} src={`/community-icons/${event.icon}.png`} alt={event.value} />
                            {event.label}
                            <div
                                className={classes.smallDeleteButton}
                                onClick={(e) => removeEvent(event, 'event')}
                            />
                        </div>
                    ))
            )}
        </div>
      </div>
    </div>
  );
};

export default CommunityActivity;